import { render, staticRenderFns } from "./AllocationUserDetails.vue?vue&type=template&id=b446e114"
import script from "./AllocationUserDetails.vue?vue&type=script&lang=js"
export * from "./AllocationUserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports